]
<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">
        <t-input v-model="form.compoundId" hidden/>

        <b-row>

          <t-input v-model="form.name"  cols="9" :add-error="error.name" label="Descrição" required/>

          <t-input v-model="form.compoundCodeLabel" v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                   :add-error="error.compoundCodeLabel" upper cols="3"
                   label="Cód. Composto"
                   code-label
                   help="Código inserido manualmente conforme configurado em Produtos > Configurações > Parâmetros"
                   required/>

          <t-input v-model="form.compoundCodeLabel"
                   v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                   :add-error="error.compoundCodeLabel" upper cols="3"
                   fixed
                   label="Cód. Composto"
                   help="Código inserido automaticamente conforme configurado em Produtos > Configurações > Parâmetros"
          />




        </b-row>

        <t-input v-model="form.typeCompoundId"
                 :options="typeCompoundOptions" :add-error="error.typeCompoundId"
                 label="Grupo de Composto" required select>

          <!--        <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-type-mold',search)">Cadastrar novo Tipo de Ferramenta</b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar Tipo de Ferramenta" @click="openDialogForm('modal-type-mold')" icon-plus/>
                  </template>-->

        </t-input>


        <b-row>

          <t-input v-model="form.shore" cols="6" label="Shore" required/>

          <t-input v-model="form.typeColorCompoundId" cols="6" label="Cor" required select-colors
                   :options="typeColorCompoundOptions"/>

        </b-row>

        <!--ATENÇÃO NÃO ESQUECER DE UTILIZAR template #default="{status} para funcionamento correto-->
        <t-page-form-field-customized
            ref="fieldsGeneral"
            :command="command" :status="status" :user-auth="userAuth"
            :fields-customizable="entityFieldCustomized('page')"
            :primary-key="form.instrumentId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
            :primary-key-column="fieldKey" foreign-key-column="pageId"
        />


        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import typeCompoundService from "@/services/modules/product/TypeCompound.service";
import typeColorCompoundService from "@/services/modules/general/TypeCompoundColor.service";
import SettingType from "@/model/types/resource/SettingType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'CompoundForm',
  data() {
    return {
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: true,
      fieldKey: "compoundId",
      form: {
        compoundId: 0,
        compoundCodeLabel: "",
        compoundNumber: 0,
        typeCompoundId: 0,
        typeColorCompoundId: 0,
        name: "",
        shore: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        compoundCodeLabel: "",
        typeCompoundId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      noOptionAdd: "",
      typeCompoundOptions: [],
      typeColorCompoundOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await typeCompoundService.selectList("").then((list) => {
        this.typeCompoundOptions = list
      }).catch(error => this.responseError(error))


      await typeColorCompoundService.selectList("").then((list) => {
        this.typeColorCompoundOptions = list
      }).catch(error => this.responseError(error))

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>
